import React from 'react';
import Grade11Sewa2023  from 'views/Grade11Sewa2023';

const SecondarySchoolpage = () => {
  return <Grade11Sewa2023/>;
};

export default SecondarySchoolpage;